import { Avatar } from "antd";
import styled from "styled-components";

export const AvatarStyle = styled(Avatar)``;
export const AvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`;
export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
`;
export const ParaStyle = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: ${(props) => props.theme.textcolordblack};
`;
export const SpanStyle = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: ${(props) => props.theme.colorbluegrey};
`;
